const NumberValidator = {
  isValidInteger: (numberString, maxDigits) => {
    const regex = new RegExp('^$|^0$|^([1-9][0-9]*)$');
    return !numberString || (numberString.match(regex) && numberString.length <= maxDigits);
  },
  isValidDecimal: (numberString, maxDigits, maxDecimals) => {
    if ('' === numberString) {
      return true;
    }
    const regex = new RegExp('^(\\d+)(\\.(\\d+)?)?$');
    const matches = regex.exec(numberString);
    return matches &&
      NumberValidator.isValidInteger(matches[1], maxDigits) &&
      (!matches[3] || NumberValidator.isValidInteger(matches[3], maxDecimals));
  },
};

export default NumberValidator;